import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { restURL } from "../../../Models/restURL";
import { Subscription } from "rxjs";
import { LanguageService } from './../../../Services/languageService';
import Swal from 'sweetalert2';
import { mdlCheckPaymentStatusRes } from "../../../Models/mdlCheckPaymentStatusRes";
import { mdlCheckPaymentStatusReq } from "../../../Models/mdlCheckPaymentStatusReq";
import { mdlProposalAddRes_Upgrade } from '../../../Models/mdlProposalAddRes_Upgrade';
import { renewPolicyModel } from '../../../Models/policyModel';
import { ProposalModel } from '../../../Models/ProposalModel';
import { mdlCheckEligibilityRes } from '../../../Models/mdlCheckEligibilityRes';
import { mdlPayFortRequestDetailsRes } from '../../../Models/mdlPayFortRequestDetailsRes';
import { motorProposalService } from '../../../Services/motorProposalService';

@Component({
  selector: 'PayfortStatusUpgrade',
  templateUrl: './PayfortStatusUpgrade.html',
  styleUrls: ['./PayfortStatusUpgrade.css']
})
export class PayfortStatusUpgrade {

  public ProposalNo: string;
  public LngSubscription: Subscription;
  public Lng: string;
  public isShowLoading: boolean;
  public PaymentDate;
  public TotalPremium: number;
  public InsuredName: string;
  public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  public objProposalAddRes_Upgrade: mdlProposalAddRes_Upgrade = new mdlProposalAddRes_Upgrade();
  public proposalObj: ProposalModel = new ProposalModel();
  public objCheckEligibilityRes: mdlCheckEligibilityRes = new mdlCheckEligibilityRes();
  public objmdlCheckPaymentStatusRes: mdlCheckPaymentStatusRes = new mdlCheckPaymentStatusRes();
  public objmdlCheckPaymentStatusReq: mdlCheckPaymentStatusReq = new mdlCheckPaymentStatusReq();
  public objmdlPayFortRequestDetailsRes: mdlPayFortRequestDetailsRes = new mdlPayFortRequestDetailsRes();
    
  constructor(private EncriptService: motorProposalService, private http: HttpClient, private url: restURL, private lngService: LanguageService){
    this.LngSubscription = this.lngService.grtLng().subscribe(lng => {
      this.Lng = lng
    });
    this.CheckPaymentStatus();
  }

  //<<<<<<<<<CheckPaymentStatus START>>>>>>>>>>>>>>>>>>>
  CheckPaymentStatus() {
    this.objProposalAddRes_Upgrade = JSON.parse(sessionStorage.getItem("objProposalAddRes_Upgrade"));
    this.objCheckEligibilityRes = JSON.parse(sessionStorage.getItem("objCheckEligibilityRes"));
    if(sessionStorage.getItem("paymentObj") != null){
      this.proposalObj = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("paymentObj")));
    }

 
    this.ProposalNo = this.objProposalAddRes_Upgrade.ProposalNo ? this.objProposalAddRes_Upgrade.ProposalNo : this.proposalObj.ProposalNo;
  
    this.TotalPremium = this.objCheckEligibilityRes.TOTAL_AMOUNT_UPGRADE ? this.objCheckEligibilityRes.TOTAL_AMOUNT_UPGRADE : this.proposalObj.TotalPremium;
  
    this.InsuredName = this.Lng == "en" ? sessionStorage.getItem("InsuredName") : sessionStorage.getItem("NameAr");
  

    this.objmdlPayFortRequestDetailsRes = JSON.parse(sessionStorage.getItem("objmdlPayFortRequestDetailsRes"));
   
    this.PaymentDate = Date.now();
    this.objmdlCheckPaymentStatusReq.ProposalNo = this.ProposalNo;
 
    this.objmdlCheckPaymentStatusReq.MerchentReferenceNo = this.objmdlPayFortRequestDetailsRes.merchant_reference;
   
    this.isShowLoading = true;
    this.http.post<mdlCheckPaymentStatusRes>(this.url.LimraOnlinePaymentsURL + "/OnlinePayments/CheckPaymentStatus", this.objmdlCheckPaymentStatusReq, this.httpOptions).toPromise().then((objCheckStatus) => {
      this.objmdlCheckPaymentStatusRes = objCheckStatus;
      this.isShowLoading = false;
      if (this.objmdlCheckPaymentStatusRes.PaymentStatus == "1" ) {
          
          Swal("<img src='assets/img/Acig.png' style='width: 25%;height: 25%;'>", "<h5 style='color:green'>Payment Done Successfully If Details Not Found Please click On Refresh Button, thank you for choosing ACIG</h5> ", "info");
      }
      else {
          Swal("<img src='assets/img/Acig.png' style='width: 25%;height: 25%;'>", "<h5 style='color:red'>Payment Not Done Thank You For Choosing Acig</h5> ", "info");
      }
    }, 
      (error) => {
          this.isShowLoading = false;
          Swal("<img src='assets/img/Acig.png' style='width: 25%;height: 25%;'>", "<h5 style='color:red'>Somethig Went Wrong Please Refresh Page</h5> ", "info");
    });
  }
  //<<<<<<<<<CheckPaymentStatus END>>>>>>>>>>>>>>>>>>>


}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/PayfortUpgrade/PayfortStatusUpgrade/PayfortStatusUpgrade.ts